import { QueryOptions } from "api/api.types"
import { SenderType } from "ts/types/SenderType"

export enum ExportType {
  TEACHER_TRANSACTIONS = "TEACHER_TRANSACTIONS",
  SCHOOL_TRANSACTIONS = "SCHOOL_TRANSACTIONS",
  STUDENT_TRANSACTIONS = "STUDENT_TRANSACTIONS",
  CLASS_STORE_TRANSACTIONS = "CLASS_STORE_TRANSACTIONS",
  STUDENT_STORE_TRANSACTIONS = "STUDENT_STORE_TRANSACTIONS",
  CLASS_STUDENTS = "CLASS_STUDENTS",
  CLASS_JOBS = "CLASS_JOBS",
  STUDENT_JOBS = "STUDENT_JOBS",
  CLASS_GROUPS = "CLASS_GROUPS",
  GROUP_STORE_TRANSACTIONS = "GROUP_STORE_TRANSACTIONS",
  SCHOOL_GROUPS = "SCHOOL_GROUPS",
}

export enum ExportStatus {
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
  FAILURE = "FAILURE",
}

export interface IExportReportResponse {
  id: number
  export_type: ExportType
  status: ExportStatus
  filename: string
  task_id: string
  file_key: string
  download_url: string
  created_at: string
  updated_at: string
  expires_at: string
}

export interface IExportStudentJobsTaskArgs {
  studentId: number
  options?: QueryOptions<IExportTaskResponse>
}

export interface IExportStudentTransactionsTaskArgs {
  studentId: number
  options?: QueryOptions<IExportTaskResponse>
}

export interface IExportStudentStoreTransactionsTaskArgs {
  classId: number
  studentId: number
  options?: QueryOptions<IExportTaskResponse>
}

export interface IExportClassJobsTaskArgs {
  classId: number
  options?: QueryOptions<IExportTaskResponse>
}

export interface IExportClassStoreTransactionsTaskArgs {
  classId: number
  options?: QueryOptions<IExportTaskResponse>
}

export interface IExportGroupsTaskArgs {
  classId: number
  group_ids?: number[]
  options?: QueryOptions<IExportTaskResponse>
}

export interface IExportSchoolGroupsTaskArgs {
  options?: QueryOptions<IExportTaskResponse>
}

export interface IExportGroupStoreTransactionsTaskArgs {
  classId: number
  group_ids?: number[]
  options?: QueryOptions<IExportTaskResponse>
}

export interface IExportTaskResponse {
  id: number
  export_type: ExportType
  status: ExportStatus
  filename: string
  task_id: string
  file_key: string | null
  download_url: string | null
  created_at: string
  updated_at: string
  expires_at: string | null
}

export interface IExportTeacherTransactionsArgs {
  classes?: number[]
  group_ids?: number[]
  type_in?: string[]
  date_from?: string
  date_to?: string
  title_filter?: string
  student_filter?: string
  sender_type?: SenderType
  options?: QueryOptions<IExportTaskResponse>
}

export interface IExportClassStudentsArgs {
  classId: number
  options?: QueryOptions<IExportTaskResponse>
}

export interface IExportReportByIdArgs {
  exportReportId: number
  options?: QueryOptions<IExportReportResponse>
}

export interface IExportReportDownloadResponse {
  download_url: string
}

export interface IExportReportDownloadArgs {
  exportReportId: number
  options?: QueryOptions<IExportReportDownloadResponse>
}
